import { HugeiconsIcon } from "@hugeicons/react";
import { MazeIcon, Search01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  title: string;
  subtitle: string;
  surpriseMeLabel: string;
  onSurpriseMe?: () => void;
};

const SearchEmptyState: FC<Props> = ({
  title,
  subtitle,
  surpriseMeLabel,
  onSurpriseMe,
}) => (
  <div className="flex flex-col items-center justify-center gap-4 py-10 text-center">
    <div className="hidden relative md:flex h-40 w-40 items-center justify-center">
      <div className="absolute h-28 w-20 rounded-lg bg-linear-to-b from-white/10 to-transparent -rotate-12 -translate-x-10 translate-y-2">
        <div className="h-full w-full rounded-lg bg-linear-to-b from-secondary to-transparent" />
      </div>
      <div className="absolute h-28 w-20 rounded-lg bg-linear-to-b from-white/10 to-transparent p-px rotate-12 translate-x-10 translate-y-2">
        <div className="h-full w-full rounded-lg bg-linear-to-b from-secondary to-transparent" />
      </div>
      <div className="absolute h-28 w-20 rounded-lg bg-linear-to-b from-white/10 to-transparent p-px">
        <div className="h-full w-full rounded-lg bg-secondary" />
      </div>
      <HugeiconsIcon
        icon={Search01Icon}
        size={48}
        className="relative z-10 text-muted-foreground"
      />
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-lg md:text-2xl font-bold">{title}</p>
      <p className="text-muted-foreground text-sm md:text-base font-semibold">
        {subtitle}
      </p>
    </div>
    <Button variant="default" size="xl" onClick={onSurpriseMe}>
      <HugeiconsIcon icon={MazeIcon} />
      {surpriseMeLabel}
    </Button>
  </div>
);

export default SearchEmptyState;
